import { createAction, ActionsUnion } from 'utils/redux'
import {
  GridId,
  GridSettingsId,
  GridSettings,
  GridStore,
  GridColumnSettings,
  GlobalGridSettings,
  GridColumnCopySelection,
  GridBulkDateUpdateFields
} from './gridTypes'

export enum GridActionTypes {
  GRID_INITIALIZE = 'GRID_INITIALIZE',
  GRID_UPDATE_SETTINGS = 'GRID_UPDATE_SETTINGS',
  GRID_DELETE_VIEW = 'GRID_DELETE_VIEW',
  SAVE_COLUMN_SETTINGS = 'SAVE_COLUMN_SETTINGS',
  SAVE_COLUMN_COPY_SETTINGS = 'SAVE_COLUMN_COPY_SETTINGS',
  SAVE_BULK_DATE_UPDATE_FIELDS = 'SAVE_BULK_DATE_UPDATE_FIELDS',
  SAVE_GLOBAL_GRID_SETTINGS = 'SAVE_GLOBAL_GRID_SETTINGS',
  SAVE_COLLAPSED_ROW_IDS = 'SAVE_COLLAPSED_ROW_IDS',
  SAVE_SELECTED_ITEM_IDS = 'SAVE_SELECTED_ITEM_IDS'
}

export const GridActions = {
  initialize: (gridStore: Partial<GridStore>) => createAction(GridActionTypes.GRID_INITIALIZE, gridStore),
  updateSettings: (gridId: GridId, settingsId: GridSettingsId, settings: GridSettings) =>
    createAction(GridActionTypes.GRID_UPDATE_SETTINGS, { gridId, settingsId, settings }),
  deleteView: (gridId: GridId, gridSettingsId: GridSettingsId) =>
    createAction(GridActionTypes.GRID_DELETE_VIEW, { gridId, gridSettingsId }),
  saveGridColumnSettings: (gridId: GridId, gridSettingsId: GridSettingsId, columnSettings: GridColumnSettings) =>
    createAction(GridActionTypes.SAVE_COLUMN_SETTINGS, { gridId, gridSettingsId, columnSettings }),
  saveSelectedItemIds: (gridId: GridId, gridSettingsId: GridSettingsId, selectedItemIds: string[]) =>
    createAction(GridActionTypes.SAVE_SELECTED_ITEM_IDS, { gridId, gridSettingsId, selectedItemIds }),
  saveGridColumnCopySelections: (gridId: GridId, gridSettingsId: GridSettingsId, columnCopySelections: GridColumnCopySelection[]) =>
    createAction(GridActionTypes.SAVE_COLUMN_COPY_SETTINGS, { gridId, gridSettingsId, columnCopySelections }),
  saveGridBulkDateUpdateFields: (gridId: GridId, gridSettingsId: GridSettingsId, bulkDateUpdateFields: GridBulkDateUpdateFields) =>
    createAction(GridActionTypes.SAVE_BULK_DATE_UPDATE_FIELDS, { gridId, gridSettingsId, bulkDateUpdateFields }),
  saveGlobalGridSettings: (globalGridSettings: Partial<GlobalGridSettings>) =>
    createAction(GridActionTypes.SAVE_GLOBAL_GRID_SETTINGS, { globalGridSettings }),
  saveCollapsedRowKeys: (gridId: GridId, gridSettingsId: GridSettingsId, collapsedRowKeys: string[]) =>
    createAction(GridActionTypes.SAVE_COLLAPSED_ROW_IDS, { gridId, gridSettingsId, collapsedRowKeys })
}

export type GridActions = ActionsUnion<typeof GridActions>
